exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ix-shipping-zone-choices[data-v-4f1c8fa5] {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    -moz-column-gap: 1.5rem;\n         column-gap: 1.5rem;\n    max-height: 280px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: .25rem .5rem;\n    border: 1px solid #dee2e6;\n    border-radius: .25rem;\n}\n.ix-shipping-rate-col[data-v-4f1c8fa5] {\n    width: 150px;\n}\n.ix-shipping-zone-choices .iti-flag[data-v-4f1c8fa5] {\n    display: inline-block;\n    vertical-align: middle;\n}\n", ""]);

// exports
